<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <div class="top-main-options">


            <v-select style="display: inline-block; width: 200px; vertical-align: top;" class="mr-4" color="#c42111" label="Log Type" v-model="logType" outlined dense :items="logTypeOptions" />

            <!-- <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn style="vertical-align: top;" height="40" class="mr-6" max-width="40" min-width="40" color="#C42111" @click="refreshLog" v-on="on"><v-icon color="#ffffff">mdi-refresh</v-icon></v-btn>
                </template>
                <span>Refresh Log</span>
            </v-tooltip> -->

            <v-menu offset-y nudge-left="0" nudge-top="0" z-index="1001" :content-class="'no-box'" :close-on-content-click="false">
                <template #activator="{ on: onMenu }">
                    <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                        <template #activator="{ on: onTooltip }">
                            <v-btn style="vertical-align: top;" height="40" class="mr-6" max-width="40" min-width="40" color="#C42111" title="Options" v-on="{ ...onMenu, ...onTooltip }">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <span>Options</span>
                    </v-tooltip>
                </template>

                <div class="options-area">
                    <v-card>
                        <v-card-text>


                            <v-radio-group v-model="logParamsType">
                                <v-radio color="#C42111" label="Entire File" :value="1" />

                                <v-divider class="mt-3 mb-4" />

                                <v-radio color="#C42111" label="Date Range" :value="2" />
                                <v-row dense>
                                    <v-col cols="12" md="6">
                                        <v-datetime-picker label="Start Date/Time" :textFieldProps="tfProps" v-model="startDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-datetime-picker label="End Date/Time" :textFieldProps="tfProps" v-model="endDateTime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                                    </v-col>
                                </v-row>
                            </v-radio-group>
                            
                            


                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn text @click="refreshLog">Run</v-btn>
                        </v-card-actions>
                    </v-card>
                    
                </div>
            </v-menu>


            <v-switch style="display: inline-block; margin-top: 12px !important;" color="#c42111" v-model="processRequests" label="Group Request/Response" @change="changedParseSettings" />


            <!-- <div class="file-picker">
                <v-file-input color="#C42111" v-model="selectedLogFile" accept="" label="Log File"  @change="changedParseSettings" placeholder="Select a log file" show-size :rules="[$store.state.validationFuncs.maxFileSize(selectedLogFile, maxFileSize, maxFileSizeStr)]" />
            </div> -->

            <div class="log-meta-data">
                <span>{{ logMetaData }}</span>
            </div>

            <div class="right-side">
                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn style="vertical-align: top;" height="40" class="mr-6" max-width="40" min-width="40" color="#C42111" @click="downloadLogFile" v-on="on"><v-icon color="#ffffff">mdi-cloud-download</v-icon></v-btn>
                    </template>
                    <span>Download Log File</span>
                </v-tooltip>

                <vue-dropzone ref="myVueDropzone" id="file-dropzone" :class="{'drag-active': dragActive}" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-file-added="handleFile" 
                    @vdropzone-drag-enter="dragActive = true" @vdropzone-drag-over="dragActive = true" @vdropzone-drag-leave="dragActive = false" :include-styling="false">
                    <div class="dropzone-custom-content">
                        <h3 class="title">Drag and drop to view log file</h3>
                        <div class="subtitle">or click to select a file from your computer</div>
                    </div>
                </vue-dropzone>
                <div class="file-error" v-if="fileError">
                    <span v-text="fileError" />
                </div>
            </div>

        </div>


        <v-progress-linear class="progress-bar" v-model="downloadProgress" color="#C42111" height="25" v-if="downloadProgress != 100">
            <strong>{{ Math.ceil(downloadProgress) }}%</strong>
        </v-progress-linear>


        <div id="ag-grid-container">
            <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                :gridOptions="gridOptions"
                :groupHeaders="true"
                :isRowMaster="isRowMaster"
                :detailCellRendererParams="detailCellRendererParams"
                :masterDetail="true"
                :getRowHeight="getRowHeight">
            </ag-grid-vue>
        </div>

        <v-dialog v-model="showUserInfoDialog" max-width="80%" width="1000px" persistent @keydown="(k) => {k.key == 'Escape' ? showUserInfoDialog = false : null}">
            <user-info v-if="showUserInfoDialog" :selectedUser="selectedUser" @close="showUserInfoDialog = false" />
        </v-dialog>

        <v-dialog v-model="showError" max-width="80%" width="1000px" persistent @keydown="(k) => {k.key == 'Escape' ? showError = false : null}">
            <v-card v-if="showError">
                <v-card-title>
                    <span>{{ selectedErrorRow.type }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-4">
                    <span style="white-space: pre-line">{{ selectedErrorRow.error }}</span>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn text @click="showError = false; selectedErrorRow = null;">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import _ from 'lodash';
import vue2Dropzone from 'vue2-dropzone';
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import UserInfo from "@/components/ApplicationLogs/UserInfo";
export default {
    name: 'ApplicationLogs',
    props: [],
    components: {
        vueDropzone: vue2Dropzone,
        'ag-grid-vue': AgGridVue,
        UserInfo
    },
    data: () => ({
        //logTypeOptions: ['application', 'socketmonitor'],
        logTypeOptions: ['application'],
        logType: 'application',
        logParamsType: 1,
        startDateTime: null,
        endDateTime: null,
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },
        tfProps: {
            color: '#c42111'
        },

        showGrid: false,
        gridOptions: null,
        detailCellRendererParams: {},
        isRowMaster: null,
        maxFileSize: 50000000,
        rawLogText: "",
        selectedLogFile: null,
        dropzoneOptions: {
            url: (TELSA.apiHost + "sitebook/files/upload"),
            thumbnailWidth: 150,
            maxFilesize: 9999999999,
            parallelUploads: 6,
            autoQueue: false,
            createImageThumbnails: false,
            previewTemplate: '<div></div>',
        },
        showImagePreview: false,
        imagePreview: null,
        dragActive: false,
        fileError: null,
        downloadProgress: 0,
        lines: 0,
        numOfUnprocessedEntries: 0,
        logEntries: [],
        processRequests: true,
        selectedUser: null,
        showUserInfoDialog: false,
        specialUsers: ['telsa-webapp'],
        showError: false,
        selectedErrorRow: null
    }),

    computed: {
        maxFileSizeStr() {
            return TELSA.readableFileSize(this.maxFileSize);
        },

        logMetaData() {
            if(this.selectedLogFile) {
                console.log('logMetaData: ', this.selectedLogFile);
                return `${this.selectedLogFile.name} (${TELSA.readableFileSize(this.selectedLogFile.size)})`;
            }
            return `All (${this.numOfUnprocessedEntries}) entries from ${this.logType} log`;
            //return `All (${this.logEntries.length}) entries from ${this.logType} log`;
        }
    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.logEntries;
            this.gridOptions.columnDefs = this.createColumnDefs();
            this.detailCellRendererParams = this.createSubColumnDefs();
            this.gridOptions.keepDetailRows = true;
            this.gridOptions.keepDetailRowsCount = 2;
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            };

            this.isRowMaster = function(data) {
                return ((data.responses && data.responses.length) || (data.errors && data.errors.length));
            };

            this.getRowHeight = function(params) {
                if(params.node && params.node.detail) {
                    const offset = 100;
                    let subRows = (params.data.responses || []).concat(params.data.errors || []);
                    return ((subRows.length * 30) + offset);
                }
                //return (self.gridSmallMode ? 24 : 40);
                return 30
            };

            this.gridOptions.getRowStyle = function(params) {
                if(!params.data) {
                    console.log('grouped row');
                }

                if(params.data.level == 'INFO') {
                    if(self.processRequests && params.data.errors && params.data.errors.length) {
                        return {background: '#ff5252', color: '#000000'};    
                    }
                }
                else if(params.data.level == 'ERROR') {
                    return {background: '#ff5252', color: '#000000'};
                }
            }

            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            let paddingTop = 2;
            columnDefs = [
                { 
                    headerName: 'Timestamp', 
                    sort: 'asc',
                    field: 'timestamp', 
                    width: 100, filter: 'date', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                },
                { 
                    headerName: 'PID', 
                    field: 'pid', 
                    width: 30, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'Level', 
                    field: 'level', 
                    width: 50, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            if(params.data.level == 'ERROR') {
                                this.eGui.innerHTML = `<span class="logs-level application-error">${params.data.level}</span>`;
                            }
                            else {
                                this.eGui.innerHTML = `<span class="logs-level">${params.data.level}</span>`;
                            }
                            this.errorClickHandler = this.errorClickHandler.bind(this);
                            this.user = this.eGui.querySelectorAll('.logs-level')[0];
                            this.user.addEventListener('click', this.errorClickHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        errorClickHandler(event) {
                            self.showErrorInfo(event, this.params.data);
                        }
                        destroy() {
                            this.user.removeEventListener('click', this.errorClickHandler);
                        }
                    },
                },
                { 
                    headerName: 'Type', 
                    field: 'type', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                    cellRenderer: "agGroupCellRenderer",
                },
                { 
                    headerName: 'Key', 
                    field: 'key', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                {
                    headerName: 'Username', 
                    //field: 'username', 
                    width: 120, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            if(self.specialUsers.includes(params.data.username)) {
                                this.eGui.innerHTML = params.data.username ? `<span class="logs-username special">${params.data.username}</span>` : `<span class="logs-username"></span>`;
                            }
                            else {
                                this.eGui.innerHTML = params.data.username ? `<span class="logs-username">${params.data.username}</span>` : `<span class="logs-username"></span>`;
                            }
                            this.userClickHandler = this.userClickHandler.bind(this);
                            this.user = this.eGui.querySelectorAll('.logs-username')[0];
                            this.user.addEventListener('click', this.userClickHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        userClickHandler(event) {
                            self.showUserInfo(event, this.params.data);
                        }
                        destroy() {
                            this.user.removeEventListener('click', this.userClickHandler);
                        }
                    },
                },
                { 
                    headerName: 'Version', 
                    field: 'version', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'IP Address', 
                    field: 'ip', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'Method', 
                    //field: 'method', 
                    width: 50, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                    cellRenderer: function(params) {
                        if(!params.data || !params.data.method) {
                            return;
                        }
                        let eElement = document.createElement('div');
                        eElement.classList.add('logs-method');
                        let color = '#61AFFE'; // GET
                        if(params.data.method == 'POST') {
                            color = '#49CC90';
                        }
                        eElement.style.backgroundColor = color;
                        eElement.innerHTML = `<span>${params.data.method}</span>`
                        return eElement;
                    }.bind(this)
                },
                { 
                    headerName: 'Route', 
                    field: 'route', 
                    width: 100, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'User Agent', 
                    field: 'userAgent', 
                    width: 160, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'Args Json', 
                    field: 'argsJson', 
                    width: 160, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
                { 
                    headerName: 'Error', 
                    field: 'error', 
                    width: 90, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'} 
                },
            ];
            if(!this.processRequests) {
                columnDefs.push({ 
                    headerName: 'Response Time (seconds)',
                    field: 'responseTime', 
                    width: 160, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'}     
                });
                columnDefs.push({
                    headerName: 'Response Size Uncompressed (bytes)', 
                    width: 210, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(!params.data || isNaN(parseInt(params.data.responseSize))) {
                            return;
                        }
                        return TELSA.readableFileSize(parseInt(params.data.responseSize));
                    },
                    comparator: (valueA, valueB, nodeA, nodeB) => {
                        let a = nodeA.data.responseSize ? parseInt(nodeA.data.responseSize) : 0;
                        let b = nodeB.data.responseSize ? parseInt(nodeB.data.responseSize) : 0;
                        return a - b;
                    }
                });
            }
            return columnDefs;
        },

        createSubColumnDefs: function() {
            let self = this;
            let paddingTop = 2;
            return {
                detailGridOptions: {
                    columnDefs: [
                        { field: "timestamp" },

                        { 
                            headerName: 'Level', 
                            //field: 'level', 
                            width: 90, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                            cellRenderer: class {
                                init(params) {
                                    this.params = params;
                                    this.eGui = document.createElement('div');
                                    if(params.data.level == 'ERROR') {
                                        this.eGui.innerHTML = `<span class="logs-level application-error">${params.data.level}</span>`;
                                    }
                                    else {
                                        this.eGui.innerHTML = `<span class="logs-level">${params.data.level}</span>`;
                                    }
                                    this.errorClickHandler = this.errorClickHandler.bind(this);
                                    this.user = this.eGui.querySelectorAll('.logs-level')[0];
                                    this.user.addEventListener('click', this.errorClickHandler);
                                }
                                getGui() {
                                    return this.eGui;
                                }
                                errorClickHandler(event) {
                                    self.showErrorInfo(event, this.params.data);
                                }
                                destroy() {
                                    this.user.removeEventListener('click', this.errorClickHandler);
                                }
                            },
                        },
                        
                        { field: "type" },
                        { field: "key" },
                        { field: "username" },
                        { field: "version" },
                        { headerName: 'IP Address', field: "ip" },
                        { field: "route" },
                        { headerName: 'Response Time (seconds)', field: "responseTime", width: 160 },
                        { 
                            headerName: 'Response Size Uncompressed (bytes)', 
                            //field: 'responseSize', 
                            width: 210, filter: 'text', cellStyle: {'padding-top': `${paddingTop}px`, 'text-align': 'left'},
                            valueGetter: function(params) {
                                if(!params.data || isNaN(parseInt(params.data.responseSize))) {
                                    return;
                                }
                                return TELSA.readableFileSize(parseInt(params.data.responseSize));
                            },
                            comparator: (valueA, valueB, nodeA, nodeB) => {
                                let a = nodeA.data.responseSize ? parseInt(nodeA.data.responseSize) : 0;
                                let b = nodeB.data.responseSize ? parseInt(nodeB.data.responseSize) : 0;
                                return a - b;
                            }
                        },
                        { field: "error" },
                    ],
                    onFirstDataRendered(params) {
                        params.api.sizeColumnsToFit();
                    }
                },
                onGridReady: params => {
                    params.api.setDomLayout("autoHeight");
                },
                getDetailRowData: params => {
                    let subRows = (params.data.responses || []).concat(params.data.errors || []);
                    params.successCallback(subRows);
                }
            };
        },

        handleFile: function(file) {
            this.dragActive = false;
            console.log('handle file: ', file);
            this.selectedLogFile = file;
            this.changedParseSettings();
        },

        changedParseSettings: function() {
            this.showGrid = false;
            this.$nextTick(() => {
                this.parseLogFile();
            });
        },

        parseLogFile: function() {
            let self = this;
            //let DELIMETER = '***';
            let DELIMETER = ' ';
            let ENTRY_DELIMETER = '|*|*|\n';

            let logTextPromise;
            if(this.selectedLogFile) {
                logTextPromise = this.selectedLogFile.text();
            }
            else {
                console.log('no file');
                logTextPromise = Promise.resolve();
            }
            

            this.logEntries = [];
            logTextPromise.then(text => {
                if(text) {
                    this.rawLogText = text;
                }
                let lines = this.rawLogText.split(ENTRY_DELIMETER);
                this.numOfUnprocessedEntries = lines.length;
                for(let line of lines) {
                    let entry = {};
                    entry.timestamp = line.substring(0, 24);
                    let apiChunks = line.substring(24).split(DELIMETER, 3);
                    entry.level = apiChunks[0];
                    entry.mode = apiChunks[1];
                    entry.type = apiChunks[2];

                    if(entry.mode == 'root' && !line.includes('Starting Up')) {
                        if(entry.level == "ERROR") {
                            apiChunks = line.substring(24).split(DELIMETER);
                            let splitted = line.substring(24).split(DELIMETER);
                            apiChunks = splitted.slice(0,10);
                            apiChunks.push(splitted.slice(10).join(' '));

                            entry.level = apiChunks[0];
                            entry.mode = apiChunks[1];
                            entry.type = apiChunks[2];
                            entry.key = apiChunks[3];
                            entry.username = apiChunks[4];
                            entry.version = apiChunks[5];
                            entry.ip = apiChunks[6];
                            entry.method = apiChunks[7];
                            entry.route = apiChunks[8];
                            entry.responseTime = apiChunks[9];
                            entry.error = apiChunks[10];
                            entry.pid = apiChunks[11];
                        }
                        else if(entry.type == 'REQUEST') {
                            apiChunks = line.substring(24).split(DELIMETER);
                            let splitted = line.substring(24).split(DELIMETER);
                            apiChunks = splitted.slice(0,11);
                            apiChunks.push(splitted.slice(11).join(' '));

                            entry.level = apiChunks[0];
                            entry.mode = apiChunks[1];
                            entry.type = apiChunks[2];
                            entry.key = apiChunks[3];
                            entry.username = apiChunks[4];
                            entry.version = apiChunks[5];
                            entry.ip = apiChunks[6];
                            entry.method = apiChunks[7];
                            entry.route = apiChunks[8];
                            entry.pid = apiChunks[9];
                            entry.userAgent = apiChunks[10];
                            entry.argsJson = apiChunks[11];
                            entry.responseTime = "";
                            entry.responseSize = "";
                        }
                        else if(entry.type == 'RESPONSE') {
                            apiChunks = line.substring(24).split(DELIMETER, 11);

                            entry.argsJson = "";
                            entry.level = apiChunks[0];
                            entry.mode = apiChunks[1];
                            entry.type = apiChunks[2];
                            entry.key = apiChunks[3];
                            entry.username = apiChunks[4];
                            entry.version = apiChunks[5];
                            entry.ip = apiChunks[6];
                            entry.method = apiChunks[7];
                            entry.route = apiChunks[8];
                            entry.responseTime = apiChunks[9];
                            entry.responseSize = apiChunks[10];
                            entry.pid = apiChunks[11];
                        }
                        //console.log(`PID: ${entry.pid}`);
                        this.logEntries.push(entry);
                    }
                }


                if(this.processRequests) {
                    let logEntriesGroups = _.groupBy(this.logEntries, l => {
                        return l.key;
                    });
                    let processedEntries = [];
                    for(let [key, entryGroup] of Object.entries(logEntriesGroups)) {
                        if(entryGroup.length == 1) {
                            let processedEntry = entryGroup[0];
                            processedEntry.responses = [];
                            processedEntry.errors = [];
                            processedEntries.push(processedEntry);
                        }
                        else {
                            let processedEntry = null;
                            let responses = [];
                            let errors = [];
                            for(let entry of entryGroup) {
                                if(entry.type == 'REQUEST') {
                                    processedEntry = entry;
                                }
                                else if(entry.type == 'RESPONSE') {
                                    responses.push(entry);
                                }
                                else if(entry.level == 'ERROR') {
                                    errors.push(entry);
                                }
                            }
                            processedEntry.responses = responses;
                            processedEntry.errors = errors;
                            processedEntries.push(processedEntry);
                        }
                    }
                    this.logEntries = processedEntries;
                }

                this.buildAgGrid();
            });
        },

        showUserInfo: function(e, data) {
            if(this.specialUsers.includes(data.username)) {
                return;
            }
            this.selectedUser = this.$store.state.batchConfig.users.find(u => u.user_username == data.username);
            this.showUserInfoDialog = true;
        },

        showErrorInfo: function(e, data) {
            this.selectedErrorRow = data;
            this.showError = true;
        },

        downloadLogFile: function() {
            let file = 'application.log';
            let url = new URL(`${TELSA.staticHost}application-log-files/${file}?username=${this.$store.state.user.user_username}&access=${this.$store.state.user.user_access}`);
            console.log(url);
            let dlink = document.createElement('a');
            dlink.href = url;
            dlink.click();
            dlink.remove();
        },

        getLogs: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "log/read");
            let selectedLogType = 'application';
            let selectedLogLines = 0;
            let log_params = {
                type: this.logParamsType,
                start_datetime: this.startDateTime,
                end_datetime: this.endDateTime
            }

            // return this.$http.post(route, {args: {log_type: selectedLogType, log_params: log_params, lines: selectedLogLines}}).then(response => {
            //     let result = response.body;
            //     this.rawLogText = result;
            //     this.parseLogFile();
            //     TELSA.loading(false);
            // });


            let fetchOptions = {
                method: 'POST',
                headers: {
                    'Authorization': ('Bearer ' + localStorage.getItem('access_token')),
                    'X-Client-Version': this.$store.state.applicationVersion,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({args: {log_type: selectedLogType, log_params: log_params, lines: selectedLogLines}})
            };

            let self = this;
            return fetch(route, fetchOptions).then(response => {
                TELSA.loading(false);
                console.log('response: ', response);
                if (!response.ok) {
                    throw new Error(`HTTP Error: ${response.status}`);
                }
                
                const contentLength = response.headers.get('X-Content-Length') ? parseInt(response.headers.get('X-Content-Length'), 10) : parseInt(response.headers.get('Content-Length'), 10);
                console.log('contentLength: ', contentLength)
                let downloadedBytes = 0;
                
                
                // Need to clone this because reading it(which we're about to do) will drain the stream.
                const streamReader = response.clone().body.getReader();
                
                function read() {
                    // Initialize a progress event listener. 
                    streamReader.read().then(progressEvent => {
                        console.log(progressEvent);
                        // Starts reading, when there is progress this function will fire
                        if (progressEvent.done) {
                            console.log('Download complete. response now: ', response);
                            self.downloadProgress = 100;
                            return;
                        }
                        downloadedBytes += progressEvent.value.length;
                        const percentDownloaded = (downloadedBytes / contentLength) * 100;
                        console.log(`Downloaded: ${percentDownloaded.toFixed(2)}%`);
                        self.downloadProgress = parseInt(percentDownloaded);
                        read();
                    })
                }
                read();

                return response.json(); // Parse the response content as JSON, for example
            }).then(result => {
                // Handle the downloaded data here
                //console.log('result:', result);
                this.rawLogText = result;
                this.parseLogFile();
                TELSA.loading(false);
            })
            .catch(error => {
                console.error('Error:', error);
            });

        },

        refreshLog: function() {
            this.showGrid = false;
            this.getLogs();
        }
    },

    mounted() {
        this.startDateTime = `${TELSA.moment().format('YYYY-MM-DD')} 00:00:00`;
        this.endDateTime = TELSA.moment().format('YYYY-MM-DD HH:mm:ss');
        this.getLogs();
    }
};
</script>

<style scoped>
    .top-main-options {
        display: block;
        position: relative;
    }

    .options-area {
        background-color: #424242;
        width: 500px;
        /* height: 300px;
        padding: 8px; */
    }

    .file-picker {
        width: 20em;
        display: inline-block;
        margin-right: 2em;
    }

    .log-meta-data {
        display: inline-block;
        text-align: center;
        position: absolute;
        left: calc(50% - (300px /2));
        width: 300px;
        bottom: 15px;
        font-weight: bold;
    }

    .right-side {
        float: right;
    }

    #file-dropzone {
        
        display: inline-block;
        width: 300px;
        max-width: 300px;
        text-align: center;
        padding: 0.5em 0em 0.25em 0em;
        cursor: pointer;
        background-color: #424242;
        border: #ffffff dashed 1px;
    }

    #file-dropzone.drag-active {
        border: #4caf50 solid 1px;
        background-color: rgba(48,48,48,0.5);
    }

    .file-error {
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        color: #ff5252;
        margin-top: 0.5em;
        margin-left: 1em;
    }

    #file-dropzone .title {
        color: #ffffff;
        font-size: 1rem !important;
        font-weight: 500;
        line-height: 1rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    #file-dropzone .subtitle {
        color: #ffffff;
        font-size: 0.75rem;
    }

    .progress-bar {
        width: 80%;
        margin-left: 10%;
        margin-top: calc((50%/2) - 5%);
    }

    #ag-grid-container {
        height: calc(100vh - 150px);
        width: 100%;
    }

    .username {
        color: red !important;
        text-decoration: underline !important;
    }

</style>

<style>

    .logs-level.application-error {
        color: #000000;
        text-decoration: underline;
        cursor: pointer;
        font-weight: bold;
    }

    .logs-username {
        color: #C42111;
        text-decoration: underline;
        cursor: pointer;
    }
    .logs-username.special {
        color: #000000;
        text-decoration: none;
        cursor: default;
    }

    .logs-method {
        border-radius: 5px;
        width: 60px;
        text-align: center;
        color: #ffffff;
    }

</style>
